'use strict';

/**
 * DatasetFormController - contrôleur pour le formulaire de création/édition de jeu de données
 */
import appModule from '../../app.module';

angular.module(appModule)
.controller('DatasetFormController', ['$scope', '$uibModalInstance', 'dataset', function($scope, $uibModalInstance, dataset) {
  
  // Déterminer si c'est une création ou une édition
  $scope.isNew = !dataset.id;
  
  // Copier le dataset pour éviter de modifier l'original
  $scope.dataset = angular.copy(dataset);
  
  // Initialiser la chaîne de tags à partir du tableau de tags
  $scope.tagsString = $scope.dataset.tags ? $scope.dataset.tags.join(', ') : '';
  
  // Fonction pour convertir la chaîne de tags en tableau
  $scope.getTags = function() {
    if (!$scope.tagsString) return [];
    return $scope.tagsString.split(',').map(function(tag) {
      return tag.trim();
    }).filter(function(tag) {
      return tag.length > 0;
    });
  };
  
  // Fonction pour sauvegarder le dataset
  $scope.save = function() {
    // Valider le formulaire
    if ($scope.datasetForm.$invalid) {
      return;
    }
    
    // Convertir la chaîne de tags en tableau
    $scope.dataset.tags = $scope.getTags();
    
    // Mettre à jour la date de modification
    $scope.dataset.updatedAt = new Date().toISOString().split('T')[0];
    
    // Si c'est un nouveau dataset, ajouter la date de création
    if ($scope.isNew) {
      $scope.dataset.id = Math.floor(Math.random() * 1000) + 100; // ID temporaire pour la démonstration
      $scope.dataset.createdAt = new Date().toISOString().split('T')[0];
      $scope.dataset.views = 0;
      $scope.dataset.downloads = 0;
      $scope.dataset.resources = 0;
      $scope.dataset.image = "assets/images/placeholders/dataset-default.svg";
    }
    
    // Fermer la modal et retourner le dataset
    $uibModalInstance.close($scope.dataset);
  };
  
  // Fonction pour annuler et fermer la modal
  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
}]);
